import { z } from "zod";
import { createDocumentSchema } from "./FormGroups/DocumentFormGroup";
import { createDescriptionSchema } from "./FormGroups/DescriptionFormGroup";
import { createDeadlineSchema } from "./FormGroups/DeadlineFormGroup";
import { createEstimateSchema } from "./FormGroups/EstimateFormGroup";
import { createContractSchema } from "./FormGroups/ContractFormGroup";
import { additionalSchema } from "./FormGroups/AdditionalFormGroup";
import { createOperationalOrganizationIdsSchema } from "../Shared/FormGroups/OperationalOrganizationsFormGroup";
import { TenderType } from "@/graphql/__generated__/graphql";
import { TFunction } from "i18next";
import { executiveSummarySchema } from "../Shared/FormGroups/ExecutiveSummaryFormGroup";
import { t as translate } from "i18next";

export const createFormSchema = (t: TFunction, aiImportID: string | null) => {
  const baseSchema = z.object({
    ...createDescriptionSchema(t).shape,
    ...createDeadlineSchema(t).shape,
    ...createEstimateSchema(t).shape,
    ...createContractSchema(t).shape,
    ...additionalSchema.shape,
    ...createOperationalOrganizationIdsSchema(t).shape,
    ...executiveSummarySchema.shape,
  });

  const schemaWithDocuments = aiImportID
    ? baseSchema
    : baseSchema.extend({
      ...createDocumentSchema(t).shape,
    });

  return schemaWithDocuments.check((ctx) => {
    if (ctx.value.description.type !== TenderType.Private) {
      // Conditional validation logic for public tenders
      if (!ctx.value.deadline.publication) {
        ctx.issues.push({
          path: ["deadline", "publication"],
          message: t("schemas:createtender.publicpublicationdaterequired"),
          code: "custom",
          input: ctx.value.deadline.publication,
        });
      }

      if (!ctx.value.deadline.questions) {
        ctx.issues.push({
          path: ["deadline", "questions"],
          message: t("schemas:createtender.publicquestionsdaterequired"),
          code: "custom",
          input: ctx.value.deadline.questions,
        });
      }
    }
  });
};

export const formGroupSchemas = {
  document: createDocumentSchema(translate),
  description: createDescriptionSchema(translate),
  deadline: createDeadlineSchema(translate),
  estimate: createEstimateSchema(translate),
  contract: createContractSchema(translate),
  operationalOrganizationIds: createOperationalOrganizationIdsSchema(translate),
  additionalText: additionalSchema,
  executiveSummary: executiveSummarySchema,
};
